module.exports = __webpack_public_path__ + "img/editAppointmentPhone.a13f2fbe.png";